/**
 * 打印模板文本布局工具
 *
 * @module utils/print-template-layout
 * @description 打印模板中"多值文本"（内容以换行分隔的清单）的行列布局统一实现。
 * Web 设计器预览与 App 打印引擎（原生精臣 SDK / 钉钉小程序画布）共用同一函数，
 * 保证设计器所见与实际打印一致。
 */

/** 多值文本默认每行条目数（=1，与历史打印行为一致：每条目一行） */
export const TEXT_COLUMNS_DEFAULT = 1

/** 同一行内条目之间的分隔符（两个半角空格，避免与条目末尾的勾选框粘连） */
export const TEXT_COLUMNS_SEPARATOR = '  '

/**
 * 按「每行 N 个」重排换行分隔的多值文本。
 *
 * - `columns` 为空、非正数或等于 1：原样返回（每条目一行，历史行为）
 * - 内容不含换行：原样返回
 * - `columns > 1`：条目按行优先顺序每 N 个拼成一行，行内以两个空格分隔，行间保留换行
 *
 * @param content 已完成变量替换的文本内容
 * @param columns 每行条目数
 * @returns 重排后的文本
 */
export function applyTextColumns(
  content: string,
  columns?: null | number,
): string {
  if (!content) {
    return ''
  }
  const perRow = Math.floor(Number(columns) || TEXT_COLUMNS_DEFAULT)
  if (perRow <= TEXT_COLUMNS_DEFAULT) {
    return content
  }
  const items = content.split('\n')
  if (items.length <= 1) {
    return content
  }
  const rows: string[] = []
  for (let i = 0; i < items.length; i += perRow) {
    rows.push(items.slice(i, i + perRow).join(TEXT_COLUMNS_SEPARATOR))
  }
  return rows.join('\n')
}
